/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

const STORAGE_KEY = 'eggsconnect-bookings'

const safeGet = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
  } catch {
    return []
  }
}

const safeSet = (bookings) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(bookings))
  } catch (err) {
    console.error('bookingStorage write failed:', err)
  }
}

export const bookingStorage = {
  getAll: () => safeGet(),
  add: (booking) => {
    const bookings = safeGet()
    bookings.push(booking)
    safeSet(bookings)
  },
  getByCode: (code) => safeGet().find((b) => b.bookingCode === code),
  remove: (code) => {
    const bookings = safeGet().filter((b) => b.bookingCode !== code)
    safeSet(bookings)
  },
  sync: (serverBookings) => {
    if (!Array.isArray(serverBookings)) return []
    // Server is source of truth — replace local with server data
    safeSet(serverBookings)
    return serverBookings
  },
  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      /* ignore */
    }
  },
}
